import React from "react";
import PropTypes from "prop-types";
import SpreadsheetOptions from "./SpreadsheetOptions";
import { NodeOrMultipleNodes } from "../../../../../components/utility/Aux";

/**
 * An array of column names, represented as alphabetical letters,
 * depending on the number of visible columns
 */
const columnNames = [...Array(SpreadsheetOptions.COLUMNS).keys()].map(i =>
  String.fromCharCode(i + 97)
);

/**
 * SheetRenderer:  => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Renders a spreadsheet and its column headers in
 * a grid layout
 *
 * @param {*} props
 */
const SheetRenderer = props => (
  <table className={props.className}>
    <thead>
      <tr>
        <td className="cell read-only" />
        {columnNames.map(columnName => (
          <td key={columnName} className="cell read-only">
            {columnName.toUpperCase()}
          </td>
        ))}
      </tr>
    </thead>
    <tbody>{props.children}</tbody>
  </table>
);

SheetRenderer.propTypes = {
  /**
   * className: String
   * Class name for the table output
   */
  className: PropTypes.string,

  /**
   * children: NodeOrMultipleNodes
   * Spreadsheet body
   */
  children: NodeOrMultipleNodes.isRequired
};

SheetRenderer.defaultProps = {
  className: "data-grid"
};

export default SheetRenderer;



// WEBPACK FOOTER //
// ./src/modules/editor/manuscript/blocks/spreadsheet/SheetRenderer.js